import { Component } from 'react';
import PropTypes from 'prop-types'; // 
// Returns a function that when called will return a consecutive number

function consecutiveNumber() {
  var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (typeof begin !== 'number') {
    throw new TypeError('consecutiveNumber expects a number');
  }

  var number = begin;
  return function () {
    var res = number;
    number += 1;
    return res;
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}; // 


var Accordion = function (_React$Component) {
  inherits(Accordion, _React$Component);

  function Accordion() {
    classCallCheck(this, Accordion);

    var _this = possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      activeItemId: 0
    };
    _this.onClick = _this.onClick.bind(_this);
    _this.getId = consecutiveNumber(1);
    return _this;
  }

  Accordion.prototype.getChildContext = function getChildContext() {
    return {
      activeItemId: this.state.activeItemId,
      onClick: this.onClick,
      getId: this.getId
    };
  };

  Accordion.prototype.onClick = function onClick(id) {
    var activeItemId = this.state.activeItemId === id ? 0 : id;
    this.setState({
      activeItemId: activeItemId
    });
  };

  Accordion.prototype.render = function render() {
    return this.props.children;
  };

  return Accordion;
}(Component);

Accordion.childContextTypes = {
  activeItemId: PropTypes.oneOfType([PropTypes.number]),
  getId: PropTypes.func,
  onClick: PropTypes.func
}; // 

var AccordionItem = function (_React$Component) {
  inherits(AccordionItem, _React$Component);

  function AccordionItem(props, context) {
    classCallCheck(this, AccordionItem);

    var _this = possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      id: context.getId()
    };
    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  AccordionItem.prototype.getChildContext = function getChildContext() {
    return {
      isActive: this.context.activeItemId === this.state.id
    };
  };

  AccordionItem.prototype.onClick = function onClick() {
    this.context.onClick(this.state.id);
  };

  AccordionItem.prototype.render = function render() {
    return this.props.children({
      id: this.state.id,
      isActive: this.context.activeItemId === this.state.id,
      onClick: this.onClick
    });
  };

  return AccordionItem;
}(Component);

AccordionItem.childContextTypes = {
  isActive: PropTypes.bool
};
AccordionItem.contextTypes = Accordion.childContextTypes; // 

var AccordionItemBody = function (_React$Component) {
  inherits(AccordionItemBody, _React$Component);

  function AccordionItemBody() {
    classCallCheck(this, AccordionItemBody);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AccordionItemBody.prototype.render = function render() {
    return this.context.isActive ? this.props.children : null;
  };

  return AccordionItemBody;
}(Component);

AccordionItemBody.contextTypes = AccordionItem.childContextTypes;
export default Accordion;
export { Accordion, AccordionItem, AccordionItemBody };